export const AccessibleViewDefaultTemplate = {
    name: 'Accessible view',
    link: 'http://assistive.jcpenney.com/h5/access/index',
};

export const defaultUsableNet = {
    scriptId: 'usntA40start',
    scriptUrl: 'https://a40.usablenet.com/pt/c/jcpenney/cookiestorestart',
};

export default AccessibleViewDefaultTemplate;
